import { render, staticRenderFns } from "./admin_tag_single_review.vue?vue&type=template&id=ff825f22"
import script from "./admin_tag_single_review.vue?vue&type=script&lang=js"
export * from "./admin_tag_single_review.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./admin_tag_single_review.vue?vue&type=style&index=1&id=ff825f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports